/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonatsauswertungSpalteDto } from '../../models/monatsauswertung-spalte-dto';

export interface GetAllMonatsauswertungSpalten$Json$Params {
}

export function getAllMonatsauswertungSpalten$Json(http: HttpClient, rootUrl: string, params?: GetAllMonatsauswertungSpalten$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MonatsauswertungSpalteDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllMonatsauswertungSpalten$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MonatsauswertungSpalteDto>>;
    })
  );
}

getAllMonatsauswertungSpalten$Json.PATH = '/v1/monatsauswertungen/layouts/spalten';
